module.exports = __webpack_public_path__ + "img/storyteller.0b5f94ee.gif";